import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchApiVersion, fetchedApiVersion } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchApiVersion>;

export function* ApiVersionSaga({ meta: { callback } }: FetchActionPayload) {
  const { getApiVersion } = getAPI();
  const response: YieldOf<typeof getApiVersion> = yield call(getApiVersion);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedApiVersion(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedApiVersion(undefined, error));
  }

  if (callback) callback();
}

export default function* apiVersionSaga() {
  yield takeLatest(fetchApiVersion.type, ApiVersionSaga);
}
